import { useLiquidaciones } from "../contexts/LiquidacionesContext";
import { useAuditoria } from "../contexts/AuditoriaContext";
import { useAuditoriaUtils } from "../hooks/useAuditoriaUtils";
import { toast } from "react-toastify";
import { ModeloPost, ModeloGetUrl } from "../../ModeloCrud";

export function useLiquidarUtils() {
  const {
    liquidacionRows,
    selectedLiquidacionRows,
    updateLiquidaciones,
    loadinngListas,
    searchingValoresHonorarios,
    listasHonorariosRows,
  } = useLiquidaciones();

  const { updateAuditoria, modoAuditoria, selectedListaHonorarios } =
    useAuditoria();

  const { handleGetResumenAuditoria } = useAuditoriaUtils();

  const fetchLiquidaciones = async () => {
    try {
      updateLiquidaciones({ liquidacionRows: [], selectedLiquidacionRows: [] });
      const response = await handleGetResumenAuditoria();
      if (response.error === false) {
        updateLiquidaciones({ liquidacionRows: response.listado });
      }
    } catch (err) {
      console.error("Error al cargar liquidaciones", err);
    }
  };

  const handleLiquidarOdontologo = async (
    centroId,
    odontologoId,
    auditoriaId,
    liquidar = "SI",
    enviarEmail = "NO"
  ) => {
    if (liquidar === "NO" && enviarEmail === "NO") {
      toast.warning(
        "Debe seleccionar al menos una opción de liquidación o envío de email"
      );
      return; // cortar ejecución
    }
    console.log("Liquidando odontólogo: parametro liquidar", liquidar);
    console.log("Liquidando odontólogo: parametro enviarEmail", enviarEmail);
    if (!modoAuditoria) {
      toast.warning(
        "La fecha seleccionada no coincide con la auditoría activa"
      );
      return; // cortar ejecución
    }
    updateAuditoria({ liquidandoOdontologo: true });
    const body = {
      centroId,
      odontologoId,
      auditoriaId,
      liquidar,
      enviarEmail,
    };

    try {
      const response = await ModeloPost(
        "liquidacion", // entidad (usa el controlador AuditoriaController)
        null, // ID de la auditoría activa
        "liquidar-periodo", // ruta tipo /auditoria/{id}/ejecutar
        body
      );

      updateAuditoria({ liquidandoOdontologo: false });
      console.log("Respuesta de auditoría:", response);
      if (response.error === false) {
        return response.listado; // Retorna la respuesta completa
      } else {
        console.error(
          "❌ Error al liquidar odontologo:",
          response.errormessage
        );
        toast.error(
          response.errormessage || "Error al ejecutar la liquidación"
        );
        return { error: true, errormessage: response.errormessage };
      }
    } catch (error) {
      updateAuditoria({ liquidandoOdontologo: false });
      console.error("❌ Error al liquidar odontologo:", error);
      toast.error("Error de conexión con el servidor");
      return { error: true, errormessage: "Error de conexión" };
    }
  };

  const handleLiquidarSeleccionados = async (
    modo = "liquidarYEnviar",
    idsForzar = null
  ) => {
    const ids = idsForzar || selectedLiquidacionRows;

    if (!ids.length) {
      toast.warning("Debe seleccionar al menos un odontólogo");
      return;
    }

    let liquidar = "NO";
    let enviarEmail = "NO";

    if (modo === "soloEmitir") {
      liquidar = "SI";
    } else if (modo === "soloEnviar") {
      enviarEmail = "SI";
    } else {
      liquidar = "SI";
      enviarEmail = "SI";
    }

    const sortedIds = [...ids].sort((a, b) => {
      const aNombre =
        liquidacionRows.find((r) => r.odontologo_id === a)?.odontologo_nombre ||
        "";
      const bNombre =
        liquidacionRows.find((r) => r.odontologo_id === b)?.odontologo_nombre ||
        "";
      return aNombre.localeCompare(bNombre);
    });

    for (let i = 0; i < sortedIds.length; i++) {
      const id = sortedIds[i];
      const row = liquidacionRows.find((r) => r.odontologo_id === id);
      if (!row) continue;

      // 🔸 Marcar como cargando
      updateLiquidaciones({
        liquidacionRows: liquidacionRows.map((r) =>
          r.odontologo_id === id ? { ...r, isLoading: true } : r
        ),
        liquidandoNombre: row.odontologo_nombre,
        progreso: ((i + 1) / sortedIds.length) * 100,
      });

      try {
        const result = await handleLiquidarOdontologo(
          row.centro_id,
          row.odontologo_id,
          row.auditoria_id,
          liquidar,
          enviarEmail
        );

        if (result) {
          updateLiquidaciones({
            liquidacionRows: liquidacionRows.map((r) =>
              r.odontologo_id === id
                ? { ...r, pdf_filename: result, isLoading: false }
                : r
            ),
          });
        } else {
          updateLiquidaciones({
            liquidacionRows: liquidacionRows.map((r) =>
              r.odontologo_id === id ? { ...r, isLoading: false } : r
            ),
          });
        }
      } catch (err) {
        console.error(err);
        updateLiquidaciones({
          liquidacionRows: liquidacionRows.map((r) =>
            r.odontologo_id === id ? { ...r, isLoading: false } : r
          ),
        });
      }
    }

    updateLiquidaciones({
      liquidandoNombre: null,
      progreso: 0,
      selectedLiquidacionRows: [],
      searchingValoresHonorarios: false,
      selectedListaHonorariosRows: [],
    });

    //fetchLiquidaciones();
  };

  const handleBuscarValoresListaHonorarios = async () => {
    if (!selectedListaHonorarios) {
      toast.warning("No hay lista de honorarios seleccionada");
      return;
    }
    console.log("Lista seleccionada:", selectedListaHonorarios);
    updateLiquidaciones({
      searchingValoresHonorarios: true,
      selectedListaHonorariosRows: [],
    });
    try {
      let result = await ModeloGetUrl(
        "listas-precios-honorarios",
        selectedListaHonorarios.id,
        "valores-vigentes",
        null
      );
      if (result.error) {
        toast.error("Error al buscar valores vigentes: " + result.mensaje);
      } else if (result.listado && result.listado.length > 0) {
        console.log("Valores vigentes encontrados:", result.listado);
        updateLiquidaciones({ selectedListaHonorariosRows: result.listado });
      }
    } catch (error) {
      toast.error("Error al buscar valores vigentes: " + error.message);
    } finally {
      updateLiquidaciones({ searchingValoresHonorarios: false });
    }
  };

  const fetchListas = async (soloActivas = true) => {
    updateLiquidaciones({ loadingListas: true });
    try {
      let result = await ModeloGetUrl(
        "listas-precios-honorarios",
        null,
        null,
        null
      );

      console.log("Listas cargadas:", result);

      if (result.error === false && result.listado?.length > 0) {
        let listasFiltradas = soloActivas
          ? result.listado.filter((l) => l.habilitada === 1)
          : result.listado;

        updateLiquidaciones({
          listasHonorariosRows: [...listasFiltradas].sort((a, b) =>
            a.nombre.localeCompare(b.nombre)
          ),
        });
      } else {
        updateLiquidaciones({ listasHonorariosRows: [] });
      }
    } catch (error) {
      toast.error("Error al cargar listas");
      console.error(error);
    } finally {
      updateLiquidaciones({ loadingListas: false });
    }
  };

  return {
    handleLiquidarSeleccionados,
    fetchLiquidaciones,
    handleLiquidarOdontologo,
    handleBuscarValoresListaHonorarios,
    fetchListas,
  };
}
